import { createStore } from 'vuex'
import axios  from 'axios'


//const base_url = "http://localhost:3000"    //Local
//const base_url = "https://paviconapi.ubuniworks.com"    //Local

// const base_url = "http://80e9-197-237-144-194.eu.ngrok.io" //Ngrok
const base_url = process.env.VUE_APP_URL
// Helper to read token from cookie first, then fallback to localStorage
function getTokenFromCookie() {
  try {
    const match = document.cookie.split(';').map(c=>c.trim()).find(c => c.startsWith('access_token='));
    if (!match) return null;
    return decodeURIComponent(match.split('=')[1]);
  } catch (e) {
    return null;
  }
}

function getHeaders() {
  try {
    const cookieToken = getTokenFromCookie();
    const token = cookieToken || JSON.parse(localStorage.getItem('access_token')) || '';
    return { 'Authorization': 'Bearer ' + token };
  } catch (e) {
    return {};
  }
}

export default createStore({
  state: {
    units: [],
    subUnits: [],
    allUnits: [],
    categories: [],
    subcategories: [],
    tenderCategories: [],
    payments: [],
    purposes: [],
    purposesSpecify: [],
    tags: [],
    nogs: [],
    users: [],
    products: [],
    productOptions: [],
    suppliers: [],
    supplierDcouments: [],
    warehouses: [],
    purchases: {},
    batches: [],
    batchItems: [],
    dispatches: [],
    pickups: [],
    pickup:{},
    profile:{},
    approvals: [],
    approvalspending: [],
    purchasenos: [],
    roles: [],
    notes: [],
    projects: [],
    departments: [],
    documentTypes: []
  },
  mutations: { //synchrous
    setUnits (state, payload){
      state.units = payload
    },

    setDocumentTypes(state, payload){ 
      state.documentTypes = payload
    },

    setDepartments(state, payload){ 
      state.departments = payload
    },
     
    setProjects(state, payload){
      state.projects = payload
    },

    setSubUnits (state, payload){
      state.subUnits = payload
    },
    setAllUnits (state, payload){
      state.allUnits = payload
    },
    setCategories (state, payload){
      state.categories = payload
    },
    setSubCategories (state, payload){
      state.subcategories = payload
    },
    setTenderCategories (state, payload){
      state.tenderCategories = payload
    },
    setPayments (state, payload){
      state.payments = payload
    },
    setPurposes (state, payload){
      state.purposes = payload
    },
    setPurposesSpecify (state, payload){
      state.purposesSpecify = payload
    },
    setTags (state, payload){
      state.tags = payload
    },
    setNogs (state, payload){
      state.nogs = payload
    },
    setUsers (state, payload){
      state.users = payload
    },
    setProfile (state, payload){
      state.profile = payload
    },
    setProducts (state, payload){
      state.products = payload
    },
    setProductOptions (state, payload){
      var optionArray = []
      payload.forEach(product => {
        optionArray.push({ id: product.id, text: product.name})
      });
      state.productOptions = optionArray
    },
    setSuppliers (state, payload){
      state.suppliers = payload
    },
    setSupplierDocuments (state, payload){
      state.supplierDcouments = payload
    },
    setWarehouses (state, payload){
      state.warehouses = payload
    },
    setPurchases (state, payload){
      state.purchases = payload
    },
    setBatches (state, payload){
      state.batches = payload
    },
    setBatchItems (state, payload){
      state.batchItems = payload
    },
    setDispatches (state, payload){
      state.dispatches = payload
    },
    setPickups (state, payload){
      state.pickups = payload
    },
    setPickup (state, payload){
      state.pickup = payload
    },
    setApprovals (state, payload){
      state.approvals = payload
    },
    setApprovalsPending (state, payload){
      state.approvalspending = payload
    },
    setPurchasenos (state, payload){
      state.purchasenos = payload
    },
    setRoles (state, payload){
      state.roles = payload
    },
    setNotes (state, payload){
      state.notes = payload
    },
  },




 

  actions: { //asynchrous
    async fetchUnits (state) {
      const res = await fetch(base_url+'/units',{ mode: 'cors', headers: getHeaders()})
      const data = await res.json()
      state.commit("setUnits",data)
    },


    async fetchDepartments (state) {
      const res = await fetch(base_url+'/departments',{ mode: 'cors', headers: getHeaders()})
      const data = await res.json()
      console.log("Data", data)
      state.commit("setDepartments",data)
    },


    async fetchDocumentTypes (state) {
      const res = await fetch(base_url+'/documents',{ mode: 'cors', headers: getHeaders()})
      let data = await res.json()
      if(!data || data.length == 0) {
        data = [
          { name: 'Invoice' },
          { name: 'Good Issue Note' },
          { name: 'Delivery Note' },
          { name: 'Goods Receipt Note' },
          { name: 'Packing List' },
          { name: 'Others' }
        ]
      }
      console.log("Document Types", data)
      state.commit("setDocumentTypes",data)
    },


    async fetchProjects(state){
      /*const options = {
        headers: { Authorization: `Bearer 80|FJOjGAL1NIXxVGVGWgPqGwxbY71X5GTB3PcMv3YWc05c3ca6`}
      };*/
      const response = await  axios.get('https://hse-sbx.pavicontech.com/api/v2/projects', { mode: 'cors'})
      console.log(response)
      const data  = response.data.data

    
      state.commit("setProjects", data)
    },

    async fetchSubUnits (state) {
      try {
        const res = await fetch(base_url+'/units/subunits',{ mode: 'cors', headers: getHeaders()})
        if (!res.ok) {
          console.error('fetchSubUnits failed', res.status, await res.text())
          state.commit("setSubUnits",[])
          return
        }
        const data = await res.json()
        // support multiple possible response shapes
        let payload = data
        if (data && data.status === true && (data.units || data.subUnits)) payload = data.units || data.subUnits
        else if (data && data.data) payload = data.data
        state.commit("setSubUnits", Array.isArray(payload) ? payload : [])
      } catch (err) {
        console.error('Error fetching subunits', err)
        state.commit("setSubUnits",[])
      }
    },

    async fetchProfile (state)  {
      console.log("Request headers...", getHeaders())
      try {
        const res = await fetch(base_url+'/profile',{ mode: 'cors', headers: getHeaders()})
        const data = await res.json()
        console.log("Fetched", data)
        //console.log(data[data.length-1])
        const profile = data[data.length-1]
        localStorage.setItem('profile', JSON.stringify(profile))
        state.commit("setProfile",data[0])
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
      

    },

    async fetchAllUnits (state) {
      const res = await fetch(base_url+'/units/all',{ mode: 'cors', headers: getHeaders()})
      const data = await res.json()
      state.commit("setAllUnits",data)
    },
    async fetchCategories (state) {
      const res = await fetch(base_url+'/category',{ mode: 'cors', headers: getHeaders()})
      const data = await res.json()
      state.commit("setCategories",data)
    },
    async fetchSubCategories (state) {
      try {
        const res = await fetch(base_url+'/category/subcategories',{ mode: 'cors', headers: getHeaders()})
        if (!res.ok) {
          console.error('fetchSubCategories failed', res.status, await res.text())
          state.commit("setSubCategories",[])
          return
        }
        const data = await res.json()
        let payload = data
        if (data && data.status === true && (data.subcategories || data.subCategories)) payload = data.subcategories || data.subCategories
        else if (data && data.data) payload = data.data
        state.commit("setSubCategories", Array.isArray(payload) ? payload : [])
      } catch (err) {
        console.error('Error fetching subcategories', err)
        state.commit("setSubCategories",[])
      }
    },
    async fetchTenderCategories (state) {
      const res = await fetch(base_url+'/tender-category',{ mode: 'cors', headers: getHeaders()})
      const data = await res.json()
      state.commit("setTenderCategories",data.data)
    },
    async fetchPayments (state) {
      const res = await fetch(base_url+'/payments',{ mode: 'cors', headers: getHeaders()})
      const data = await res.json()
      state.commit("setPayments",data)
    },
    async fetchPurposes (state) {
      const res = await fetch(base_url+'/purposes',{ mode: 'cors', headers: getHeaders()})
      const data = await res.json()
      state.commit("setPurposes",data)
    },
    async fetchPurposesSpecify (state, payload) {
      const res = await fetch(base_url+'/purposes/'+payload,{ mode: 'cors', headers: getHeaders()})
      const data = await res.json()
      state.commit("setPurposesSpecify",data)
    },
    async fetchTags (state) {
      const res = await fetch(base_url+'/tags',{ mode: 'cors', headers: getHeaders()})
      const data = await res.json()
      state.commit("setTags",data)
    },
    async fetchNogs (state) {
      const res = await fetch(base_url+'/nogs',{ mode: 'cors', headers: getHeaders()})
      const data = await res.json()
      state.commit("setNogs",data)
    },
    async fetchUsers (state) {
      const res = await fetch(base_url+'/users',{ mode: 'cors', headers: getHeaders()})
      const data = await res.json()
      state.commit("setUsers",data)
    },

    async fetchProducts (state) {
      const res = await fetch(base_url+'/products',{ mode: 'cors', headers: getHeaders()})
      const data = await res.json()
      state.commit("setProducts",data)
      state.commit("setProductOptions",data)
    },

    async fetchProductsAdded (state) {
      const res = await fetch(base_url+'/products/added',{ mode: 'cors', headers: getHeaders()})
      const data = await res.json()
      state.commit("setProducts",data)
    },


    async fetchSuppliers (state) {
      const res = await fetch(base_url+'/suppliers',{ mode: 'cors', headers: getHeaders()})
      const data = await res.json()
      state.commit("setSuppliers",data)
      
    },


    async fetchWarehouses (state) {
      const res = await fetch(base_url+'/warehouses',{ mode: 'cors', headers: getHeaders()})
      const data = await res.json()
      state.commit("setWarehouses",data)
    },

    async fetchPurchases (state) {
      const res = await fetch(base_url+'/purchases',{ mode: 'cors', headers: getHeaders()})
      const data = await res.json()
      state.commit("setPurchases",data)
    },

    async fetchBatches (state) {
      const res = await fetch(base_url+'/batches',{ mode: 'cors', headers: getHeaders()})
      const data = await res.json()
      state.commit("setBatches",data)
    },
    async fetchDispatches (state) {
      const res = await fetch(base_url+'/dispatches',{ mode: 'cors', headers: getHeaders()})
      const data = await res.json()
      state.commit("setDispatches",data)
    },
    async fetchPickups (state) {
      const res = await fetch(base_url+'/pickups',{ mode: 'cors', headers: getHeaders()})
      const data = await res.json()
      state.commit("setPickups",data)
    },
    async fetchPickup (state, payload) {
      const res = await fetch(base_url+'/pickups/'+payload,{ mode: 'cors', headers: getHeaders()})
      const data = await res.json()
      state.commit("setPickup",data.pickup)
    },
    async fetchApprovals (state) {
      console.log("Fetching approvals...", )
      const res = await fetch(base_url+'/approvals',{ mode: 'cors', headers: getHeaders()})
      const data = await res.json()
      state.commit("setApprovals",data)
      console.log("Fetching approvals...", data)
    },
    async fetchApprovalsPending (state) {
      const res = await fetch(base_url+'/approvals/pending',{ mode: 'cors', headers: getHeaders()})
      const data = await res.json()
      state.commit("setApprovalsPending",data)
    },
    async fetchPurchasenos (state) {
      // Fetch full purchases list then filter to only stamped POs for BPN/Batch selection
      const res = await fetch(base_url+'/purchases',{ mode: 'cors', headers: getHeaders()})
      const data = await res.json()
      let purchases = []
      if (Array.isArray(data)) purchases = data
      else if (data && data.purchases) purchases = data.purchases

      console.log("All Purchases", purchases)
      
      // Keep a lightweight list of purchases including status so components can filter as needed
      const minimal = purchases.map(p => ({ id: p.id, purchaseNo: p.purchaseNo, canBeFulfilled: !!p.canBeFulfilled, status: p.status }))
      state.commit("setPurchasenos", minimal)
    },
    async fetchRoles (state) {
      const res = await fetch(base_url+'/permissions',{ mode: 'cors', headers: getHeaders()})
      const data = await res.json()
      state.commit("setRoles",data)
    },
    async fetchNotes (state) {
      const res = await fetch(base_url+'/incompletenotes',{ mode: 'cors', headers: getHeaders()})
      const data = await res.json()
      state.commit("setNotes",data)
    },
  },
  modules: {
  },
  getters: {
    getUnits : state => state.units,
    getDocumentTypes: state => state.documentTypes,
    getSubUnits : state => state.subUnits,
    getAllUnits : state => state.allUnits,
    getCategories : state => state.categories,
    getSubCategories : state => state.subcategories,
    getTenderCategories : state => state.tenderCategories,
    getPayments : state => state.payments,
    getPurposes : state => state.purposes,
    getPurposeSpecify : state => state.purposesSpecify,
    getTags : state => state.tags,
    getNogs : state => state.nogs,
    getUsers : state => state.users,
    getProducts : state => state.products,
    getProductOptions : state => state.productOptions,
    getSuppliers : state => state.suppliers,
    getWarehouses : state => state.warehouses,
    getPurchases : state => state.purchases,
    getBatches : state => state.batches,
    getDispatches : state => state.dispatches,
    getPickups : state => state.pickups,
    getPickup : state => state.pickup,
    getApprovals : state => state.approvals,
    getApprovalsPending : state => state.approvalspending,
    getPurchasenos : state => state.purchasenos,
    getRoles : state => state.roles,
    getNotes : state => state.notes,
    getProfile: state => state.profile,
    getProjects: state => state.projects,
    getDepartments: state => state.departments
  }
})
